module.exports = __webpack_public_path__ + "img/Avatar-83.fbcc2b89.svg";